import { type Err, err, type Result } from "neverthrow"

class ErrorNever extends Error {
    constructor(message: string) {
      super(message); // Pass message to the base Error constructor
      this.name = 'ErrorNever'; // Custom name for this Error subclass
      // Maintains proper stack trace for where our error was thrown (only available on V8)
      if (Error.captureStackTrace) {
        Error.captureStackTrace(this, ErrorNever);
      }
    }
  }

/**
 * Use this function as an exhaustive typescript helper
 * @param x
 */
export function expectNeverThrow(x: never, e = Error(`We should never have got here!`)): never {
    console.warn(x)
    throw e
}

export function expectNever(x : never) : Result<never, ErrorNever> {
    return err(new ErrorNever(""))
}